import { useResultContext, useConfigContext } from 'common/components/CopyMagic/contexts';
import { GENERATOR_TOP_LEVEL_CONTENT_ATTRIBUTES } from 'common/components/CopyMagic/constants';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

type AttributePath = (string | number)[];

type HookInput = {
  attributePath: AttributePath;
};

const useDeleteResultItem = ({ attributePath }: HookInput) => {
  const { result, setResultValue, resetResult } = useResultContext();
  const { generatorName } = useConfigContext();

  // Determines if the result will contain an empty content after deletion
  const nextResultIsEmpty = (attrPath: AttributePath, filteredValue: (string | object)[]) => {
    if (filteredValue.length > 0) return false; // not empty
    if (attrPath.length > 1) return false; // is nested item

    const currentTopLevelAttribute = attrPath[0];

    const allTopAttrs = GENERATOR_TOP_LEVEL_CONTENT_ATTRIBUTES[generatorName] || [];
    const filteredAttrs = allTopAttrs.filter((key) => key !== currentTopLevelAttribute);

    return (
      isEmpty(filteredAttrs) ||
      filteredAttrs.every((val) => result && val in result && isEmpty(result[val]))
    );
  };

  const onDeleteHandler = () => {
    const rootAttributePath = attributePath.slice(0, -1);
    const deleteAtIndex = attributePath[attributePath.length - 1];
    const valueAtRootAttribute = get(result, rootAttributePath);

    if (Array.isArray(valueAtRootAttribute)) {
      const filteredValue = valueAtRootAttribute.filter((_val, index) => index !== deleteAtIndex);

      if (nextResultIsEmpty(rootAttributePath, filteredValue)) {
        resetResult();
      } else {
        setResultValue(rootAttributePath, filteredValue);
      }
    }
  };
  return onDeleteHandler;
};

export default useDeleteResultItem;
